import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../Store/Reducers/UserReducer";
import { useState } from "react";
import axios from "axios";
import moment from "moment";
import { setLoader } from "../../Store/Reducers/UserReducer"
import { Modal } from "react-bootstrap";
import $ from 'jquery';
export default function MedicalStep2(props) {
  const dispatch = useDispatch();
  const MedicalHistory = props?.MedicalHistory;
  const setMedicalHistory = props?.setMedicalHistory;
  const url = process.env.REACT_APP_OXAR_API_URL;
  const [Semenanalysis, setSemenAnalysis] = useState([]);
  const [surgicalData, setsurgicalData] = useState([]);
  const [popUpData, setpopUpData] = useState();
  const [show, setshow] = useState(false);
  const regex = /^[a-zA-Z0-9\s]*$/;

  const handleShow = (detail) => {
    setshow(true)
    setpopUpData(detail)
  };

  const handleClose = () => {
    setshow(false)
  }

  const updateMedicalhistory = (data) => {
    var name = data.target.name;
    var value = data.target.value;
    setMedicalHistory(values => ({ ...values, [name]: value, 'id': MedicalHistory?.id }));
  }

  useEffect(() => {
    dispatch(setLoader(true));
    setTimeout(() => {
      const uID = localStorage.getItem('UserId');
      getMedicalHistory(uID?.id);
    }, 1000);
  }, []);

  // ***************  function for hide show pregnant filed ******************//
  const getMedicalHistory = async () => {
    dispatch(setLoader(true));
    try {
      let MainUserId = localStorage.getItem("UserID");
      await axios(`${url}api/Profile/GetSemenAnlyisbyContactID?id=${MainUserId}`).then((res) => {
        setSemenAnalysis(res.data.content);
        $("#PrevTreatmentCycleTable").DataTable();
      });
      await axios(`${url}api/Profile/GetSergicalSpermRetivalbyContactID?id=${MainUserId}`).then((res) => {
        setsurgicalData(res.data.content);
        $("#PrevTreatmentCycleTable1").DataTable();
      });
      dispatch(setLoader(false));
    }
    catch {
      dispatch(setLoader(false));
    }
  };

  let UserData = JSON.parse(localStorage.getItem("UData"));
  let MainGender = localStorage.getItem("PatientGender");
  return (
    <>
      {
    MainGender === 1 || MainGender === "1" ?
          <form>
            {/* male data of medical history */}
            <div className='card p-2'>
              <div className='row mb-2'>
                <span className='fs-5 text-dark mb-3 mt-2'>GENERAL SURGICAL AND MEDICAL HISTORY</span>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label> Have you ever had twisting of a testicle? </label>
                    </div>
                    <div className='col-md-5'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveYouEverHadTwistingofaTesticle' defaultValue={MedicalHistory?.haveYouEverHadTwistingofaTesticle} onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveYouEverHadTwistingofaTesticle === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveYouEverHadTwistingofaTesticle === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Have you had mumps?</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveYouhadMumps' defaultValue={MedicalHistory?.haveYouhadMumps} onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveYouhadMumps === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveYouhadMumps === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label> Have you had Maldescent ? </label>
                    </div>
                    <div className='col-md-5'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveyouhadmaldescent' defaultValue={MedicalHistory?.haveyouhadmaldescent}
                        onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveyouhadmaldescent === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveyouhadmaldescent === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Have you had Trauma ? </label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveyouhadtrauma' defaultValue={MedicalHistory?.haveyouhadtrauma}
                        onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveyouhadtrauma === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveyouhadtrauma === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>Have you had Varicocele ?   </label>
                    </div>
                    <div className='col-md-5'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveyouhadvaricocele' defaultValue={MedicalHistory?.haveyouhadvaricocele}
                        onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveyouhadvaricocele === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveyouhadvaricocele === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Have you had Infection ?  </label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveyouhadinfection' defaultValue={MedicalHistory?.haveyouhadinfection}
                        onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveyouhadinfection === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveyouhadinfection === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>Have you had Surgery ?   </label>
                    </div>
                    <div className='col-md-5'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveyouhadsurgery' defaultValue={MedicalHistory?.haveyouhadsurgery}
                        onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveyouhadsurgery === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveyouhadsurgery === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Have you had Chemotherapy ?  </label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveyouhadchemotherapy' defaultValue={MedicalHistory?.haveyouhadchemotherapy}
                        onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveyouhadchemotherapy === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveyouhadchemotherapy === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>Any Mental health issues?  </label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" className="form-control " name='anymentalhealthissues_male' placeholder='Enter details'
                        value={MedicalHistory?.anymentalhealthissues_male} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Family History (relevant genetic disorders) </label>
                    </div>
                    <div className='col-md-6'>
                      <input type="text" placeholder="Enter detail" className="form-control" value={MedicalHistory?.familyhistoryrelevantgeneticdisorders}
                        name='familyhistoryrelevantgeneticdisorders' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label> Have you fathered any pregnancies before? </label>
                    </div>
                    <div className='col-md-5'>
                      <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.haveyoufatheredanypregnanciesbefore}
                        name='haveyoufatheredanypregnanciesbefore' onChange={(e) => {
                          if (e.target.value === "271400001") { MedicalHistory.fatheredpregnancyifyesgivedetail = "" }
                          updateMedicalhistory(e)
                        }} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.haveyoufatheredanypregnanciesbefore === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.haveyoufatheredanypregnanciesbefore === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  {MedicalHistory?.haveyoufatheredanypregnanciesbefore === 271400000 || MedicalHistory?.haveyoufatheredanypregnanciesbefore === "271400000" ?
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>If yes, please give details</label>
                      </div>
                      <div className='col-md-6'>
                        <input type="text" placeholder="Enter detail" className="form-control " name='fatheredpregnancyifyesgivedetail'
                          value={MedicalHistory?.fatheredpregnancyifyesgivedetail} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                      </div>
                    </div>
                    : null
                  }
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>Origin of Parents (Father)   </label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.originofparentspaternal}
                        name='originofparentspaternal' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Origin of Parents (Mother)    </label>
                    </div>
                    <div className='col-md-6'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.originofparentsmaternal}
                        name='originofparentsmaternal' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>Origin of Grandparents (Maternal)     </label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.originofgrandparentsmaternal}
                        name='originofgrandparentsmaternal' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Origin of Grandparents (Paternal)    </label>
                    </div>
                    <div className='col-md-6'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.originofgrandparentspaternal}
                        name='originofgrandparentspaternal' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>Pregnancies with previous partners      </label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.pregnancieswithpreviouspartners}
                        name='pregnancieswithpreviouspartners' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Frequency / timing   </label>
                    </div>
                    <div className='col-md-6'>
                      <input type="number" className="form-control " placeholder="Frequency" value={MedicalHistory?.frequencytiming} name='frequencytiming'
                        onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-6 pe-5'>
                  <div className='row '>
                    <div className='col-md-7'>
                      <label> Do you travel away from home often?</label>
                    </div>
                    <div className='col-md-5'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='doTravelAwayFromHomeOften' defaultValue={MedicalHistory?.doTravelAwayFromHomeOften} onChange={(e) => updateMedicalhistory(e)} >
                        <option >--Select--</option>
                        <option value="271400001" selected={MedicalHistory?.doTravelAwayFromHomeOften === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.doTravelAwayFromHomeOften === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-5  pe-5'>
                  <div className='row '>
                    <div className='col-md-6'>
                      <label>Comments</label>
                    </div>
                    <div className='col-md-6'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.maleComments} name='maleComments'
                        onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <label className='mb-3'>Does your job expose you to any of the following?</label>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Heat</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='heat' defaultValue={MedicalHistory?.heat} onChange={(e) => updateMedicalhistory(e)} >
                        <option >--Select--</option>
                        <option value="271400001" selected={MedicalHistory?.heat === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.heat === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Chemicals</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='chemicals' defaultValue={MedicalHistory?.chemicals} onChange={(e) => updateMedicalhistory(e)} >
                        <option >--Select--</option>
                        <option value="271400001" selected={MedicalHistory?.chemicals === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.chemicals === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Pesticides</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='pesticides' defaultValue={MedicalHistory?.pesticides} onChange={(e) => updateMedicalhistory(e)} >
                        <option >--Select--</option>
                        <option value="271400001" selected={MedicalHistory?.pesticides === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.pesticides === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Radiation</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='radiation' defaultValue={MedicalHistory?.radiation} onChange={(e) => updateMedicalhistory(e)}  >
                        <option >--Select--</option>
                        <option value="271400001" selected={MedicalHistory?.radiation === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.radiation === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <label className='mb-3'>Do you have difficulties / problems with intercourse?</label>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Erection</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='erection' defaultValue={MedicalHistory?.erection} onChange={(e) => updateMedicalhistory(e)} >
                        <option >--Select--</option>
                        <option value="271400001" selected={MedicalHistory?.erection === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.erection === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Ejaculation</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='ejaculation' defaultValue={MedicalHistory?.ejaculation} onChange={(e) => updateMedicalhistory(e)} >
                        <option >--Select--</option>
                         <option value="271400001" selected={MedicalHistory?.ejaculation === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.ejaculation === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Penetration</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='penetration' defaultValue={MedicalHistory?.penetration} onChange={(e) => updateMedicalhistory(e)} >
                        <option >--Select--</option>
                        <option value="271400001" selected={MedicalHistory?.penetration === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.penetration === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Pain</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='pain' defaultValue={MedicalHistory?.pain} onChange={(e) => updateMedicalhistory(e)} >
                        <option >--Select--</option>
                        <option value="271400001" selected={MedicalHistory?.pain === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.pain === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <label>Dyspareunia</label>
                    </div>
                    <div className='col-md-6'>
                      <select class="form-select " id="floatingSelect" aria-label="Floating label select example" name='dyspareunia' defaultValue={MedicalHistory?.dyspareunia}
                        onChange={(e) => updateMedicalhistory(e)} >
                        <option >---Select---</option>
                        <option value="271400001" selected={MedicalHistory?.dyspareunia === 271400001}>No</option>
                        <option value="271400000" selected={MedicalHistory?.dyspareunia === 271400000}>Yes</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col text-left bg-white-200 mt-3">
                <h3 className='bg-light p-2' >Semen Analysis </h3>
                <div className="table-responsive">
                  <table class="table border-0" id="PrevTreatmentCycleTable">
                    <thead class="">
                      <tr>
                        <th> Name</th>
                        <th>Clinic Number </th>
                        <th>Performed By</th>
                        <th>Authorized By</th>
                        <th> View Details</th>
                        <th>Modified On </th>
                        <th>Detail</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Semenanalysis && Semenanalysis.map((listValue, index) => {
                        return (
                          <tr>
                            <td>{listValue.name}</td>
                            <td>{listValue.clinicnumber}</td>
                            <td>{listValue.performed_by}</td>
                            <td>{listValue.authorized_by}</td>
                            <td>{listValue.defaultSignByFormatted}</td>
                            <td>{moment(listValue.modifiedon).format("DD-MMM-YYYY")}</td>
                            <td>
                              <a onClick={() => handleShow(listValue)}>Details</a>                                                        </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-md-12 text-left bg-white-200  mt-4">
                <h3 className='bg-light p-2'>Surgical Sperm Retrieval </h3>
                <div className="table-responsive">
                  <table class="table border-0" id="PrevTreatmentCycleTable1">
                    <thead class="">
                      <tr>
                        <th> Name</th>
                        <th>Clinic Number </th>
                        <th>Age</th>
                        <th>Chromosomes</th>
                        <th> Diagnosis</th>
                        <th>CF </th>
                        <th>FSH</th>
                        <th>Post Thaw Motility</th>
                        <th>Secondary Diagnosis</th>
                        <th> Sperm Recovered</th>
                        <th>Sperm Stored </th>
                        <th>SSR By</th>
                        <th>SSR Date</th>
                        <th>Technique</th>
                        <th> Testosterone</th>
                        <th>Try To ID Name In Patient Reg </th>
                        <th>VAS Date</th>
                        <th>Y Deletions</th>
                        <th>Biopsy Result</th>
                        <th> Modified By</th>
                        <th>Modified On </th>
                        <th>Created On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {surgicalData && surgicalData.map((listValue, index) => {
                        return (
                          <tr>
                            <td>{listValue.name}</td>
                            <td>{listValue.clinic_number}</td>
                            <td>{listValue.age}</td>
                            <td>
                              {listValue.chromosomes && listValue.chromosomes === 271400000 ? "Normal" :
                                listValue.chromosomes === 271400001 ? "Abnormal" :
                                  listValue.chromosomes === 271400002 ? "Not Performed" : null}
                            </td>
                            <td>
                              {listValue.diagnosis && listValue.diagnosis === 271400000 ? "Obstructive" :
                                listValue.diagnosis === 271400001 ? "Testicular Failure" :
                                  listValue.diagnosis === 271400002 ? "Ejaculatory Dsyfunction" : null}
                            </td>
                            <td>
                              {listValue.cf && listValue.cf === 271400000 ? "Normal" :
                                listValue.cf === 271400001 ? "Abnormal" :
                                  listValue.cf === 271400002 ? "Not Performed" : null}
                            </td>
                            <td>{listValue.fsh}</td>
                            <td>
                              {listValue.post_thaw_motility && listValue.post_thaw_motility === true ? "Yes" :
                                listValue.post_thaw_motility === false ? "No" : null
                              }</td>
                            <td>
                              {listValue.diagnosis && listValue.diagnosis === 0 ? "0" :
                                listValue.secondarydiagnosis === 271400000 ? "Vasectomy" :
                                  listValue.secondarydiagnosis === 271400001 ? "CBAVD " :
                                    listValue.secondarydiagnosis === 271400002 ? "Trauma" :
                                      listValue.secondarydiagnosis === 271400003 ? "Infection" :
                                        listValue.secondarydiagnosis === 271400004 ? "Orchidopexy" :
                                          listValue.secondarydiagnosis === 271400005 ? "Chemotherapy" :
                                            listValue.secondarydiagnosis === 271400006 ? "Radiotherapy" :
                                              listValue.secondarydiagnosis === 271400007 ? "Other Surgery" :
                                                listValue.secondarydiagnosis === 271400008 ? "Other" : null}</td>
                            <td>
                              {listValue.sperm_recovered && listValue.sperm_recovered === true ? "Yes" :
                                listValue.sperm_recovered === false ? "No" : null
                              }
                            </td>
                            <td>
                              {listValue.sperm_stored && listValue.sperm_stored === true ? "Yes" :
                                listValue.sperm_stored === false ? "No" : null
                              }
                            </td>
                            <td>{listValue.ssr_by}</td>
                            <td>{moment(listValue.ssr_date).format("DD-MMM-YYYY")}</td>
                            <td>
                              {listValue.technique && listValue.technique === 271400000 ? "PESA" :
                                listValue.technique === 271400001 ? "TESE" :
                                  listValue.technique === 271400002 ? "EEJ" : null}
                            </td>
                            <td>{listValue.testosterone}</td>
                            <td>{listValue.trytoidnameinpatient_reg}</td>
                            <td>{moment(listValue.vas_date).format("DD-MMM-YYYY")}</td>
                            <td>{listValue.y_deletions && listValue.y_deletions === 0 ? "" :
                              listValue.y_deletions === 1 ? "TESE" :
                                listValue.y_deletions === 2 ? "Abnormal" :
                                  listValue.y_deletions === 3 ? "Not Performed" : null}
                            </td>
                            <td>
                              {listValue.biopsy_result && listValue.biopsy_result === 1 ? "Sertoli Cell Only Syndrome" :
                                listValue.biopsy_result === 2 ? "Maturation Arrest" :
                                  listValue.biopsy_result === 3 ? "Hypospermatogenesis" :
                                    listValue.biopsy_result === 4 ? " Ca In Situ" : null}
                            </td>
                            <td>{listValue.modifiedby}</td>
                            <td>{moment(listValue.modifiedon).format("DD-MMM-YYYY")}</td>
                            <td>{moment(listValue.createdOn).format("DD-MMM-YYYY")}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <br></br>
          </form>
          :
          // female data of medical history
          <div className=''>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> How old were you when you started periods (Menarche)? </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="number" placeholder="Enter detail" className="form-control " name='howoldwereyouwhenyoustartedperiodsmenarch'
                      value={MedicalHistory?.howoldwereyouwhenyoustartedperiodsmenarch} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Do you have bleeding between periods?</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='doYouHaveBleedingBetweenPeriods'
                      defaultValue={MedicalHistory?.doYouHaveBleedingBetweenPeriods} onChange={(e) => updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.doYouHaveBleedingBetweenPeriods === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.doYouHaveBleedingBetweenPeriods === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> What is the normal length of bleeding days? </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="number" className="form-control" placeholder="Enter detail" name='whatIsTheNormalLengthofBleedingDays'
                      defaultValue={MedicalHistory?.whatIsTheNormalLengthofBleedingDays} onChange={(e) => updateMedicalhistory(e)} />
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>What date was your last menstrual period?</label>
                  </div>
                  <div className='col-md-5'>
                    <input type="Date" className="form-control" name='whatDateWasYourLastMenstrualPeriod'
                      defaultValue={MedicalHistory?.whatDateWasYourLastMenstrualPeriod} onChange={(e) => updateMedicalhistory(e)} />
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> How long have you been trying to get pregnant (if applicable)? </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.howLongHaveYouBeenTryingtoGetPregnant}
                      name="howLongHaveYouBeenTryingtoGetPregnant" onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>How long are your cycles (days)?</label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " name='howLongAreYourCyclesDays'
                      value={MedicalHistory?.howLongAreYourCyclesDays} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Do you suffer from painful periods dysmenorrhea? </label>
                  </div>
                  <div className='col-md-5'>
                    {/* <input type="text" className="form-control " placeholder="Height in meters " Value={MedicalHistory?.doYouSufferfromPainfulPeriodsDysmenorrhoea} /> */}
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='doYouSufferfromPainfulPeriodsDysmenorrhoea'
                      defaultValue={MedicalHistory?.doYouSufferfromPainfulPeriodsDysmenorrhoea} onChange={(e) => updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.doYouSufferfromPainfulPeriodsDysmenorrhoea === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.doYouSufferfromPainfulPeriodsDysmenorrhoea === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Do you suffer from heavy periods menorrhagia?</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='doYouSufferfromHeavyPeriodsMenorrhagia'
                      defaultValue={MedicalHistory?.doYouSufferfromHeavyPeriodsMenorrhagia} onChange={(e) => updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.doYouSufferfromHeavyPeriodsMenorrhagia === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.doYouSufferfromHeavyPeriodsMenorrhagia === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Do you have bleeding after intercourse?</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='doYouExperienceBleedingAfterIntercourse'
                      defaultValue={MedicalHistory?.doYouExperienceBleedingAfterIntercourse} onChange={(e) => updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.doYouExperienceBleedingAfterIntercourse === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.doYouExperienceBleedingAfterIntercourse === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Have you ever had any previous pelvic infections?</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='haveYouEverHadAnyPreviousPelvicInfections'
                      defaultValue={MedicalHistory?.haveYouEverHadAnyPreviousPelvicInfections} onChange={(e) => updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.haveYouEverHadAnyPreviousPelvicInfections === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.haveYouEverHadAnyPreviousPelvicInfections === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> When was your last smear test?</label>
                  </div>
                  <div className='col-md-5'>
                    <input type="Date" className="form-control " defaultValue={MedicalHistory?.whenWasYourLastSmearTest}
                      onChange={(e) => updateMedicalhistory(e)} name="whenWasYourLastSmearTest" />
                  </div>
                </div>
              </div>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>What was the smear test result?</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" defaultValue={MedicalHistory?.whatWasYourLastSmearTestResult}
                      name="whatWasYourLastSmearTestResult" onChange={(e) => updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      {/* <option value="271400000">Normal</option>
                      <option value="271400001">Abnormal</option> */}
                      <option value="271400000" selected={MedicalHistory?.whatWasYourLastSmearTestResult === 271400000}>Normal</option>
                         <option value="271400001" selected={MedicalHistory?.whatWasYourLastSmearTestResult === 271400001}>Abnormal</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Are you currently using any contraceptives? </label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" defaultValue={MedicalHistory?.areyouCurrentlyUsingAnyContraceptives}
                      name="areyouCurrentlyUsingAnyContraceptives" onChange={(e) => {
                        if (e.target.value === "271400001") { MedicalHistory.contraceptivesIfYesPleaseGiveDetails = "" }
                        updateMedicalhistory(e)
                      }}>
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.areyouCurrentlyUsingAnyContraceptives === 271400001}>No</option>
                       <option value="271400000" selected={MedicalHistory?.areyouCurrentlyUsingAnyContraceptives === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                {MedicalHistory?.areyouCurrentlyUsingAnyContraceptives === 271400000 || MedicalHistory?.areyouCurrentlyUsingAnyContraceptives === "271400000" ?
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>If yes, please give details</label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.contraceptivesIfYesPleaseGiveDetails}
                        name="contraceptivesIfYesPleaseGiveDetails" onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div> : null}
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Have you ever had an abnormal blood test? </label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example"
                      name="haveYouEverhadanAbnormalTest" defaultValue={MedicalHistory?.haveYouEverhadanAbnormalTest}
                      onChange={(e) => {
                        updateMedicalhistory(e);
                        if (e.target.value === "271400001") { MedicalHistory.hadanAbnormalTestifYesPleaseGiveDetails = "" }
                      }} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.haveYouEverhadanAbnormalTest === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.haveYouEverhadanAbnormalTest === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                {MedicalHistory?.haveYouEverhadanAbnormalTest === 271400000 || MedicalHistory?.haveYouEverhadanAbnormalTest === "271400000" ?
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>If yes, please give details</label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.hadanAbnormalTestifYesPleaseGiveDetails}
                        name="hadanAbnormalTestifYesPleaseGiveDetails" onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div> : null}
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Have you ever had treatment to your cervix? </label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" defaultValue={MedicalHistory?.haveyouhadanytreatmenttoyourcervix}
                      name='haveyouhadanytreatmenttoyourcervix' onChange={(e) => {
                        updateMedicalhistory(e);
                        if (e.target.value === "271400001") { MedicalHistory.cervixTreatmentifYesPleaseGiveDetails = "" }
                      }} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.haveyouhadanytreatmenttoyourcervix === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.haveyouhadanytreatmenttoyourcervix === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                {MedicalHistory?.haveyouhadanytreatmenttoyourcervix === 271400000 || MedicalHistory?.haveyouhadanytreatmenttoyourcervix === "271400000" ?
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>If yes, please give details</label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.cervixTreatmentifYesPleaseGiveDetails}
                        name='cervixTreatmentifYesPleaseGiveDetails' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                  : null}
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Have you ever been diagnosed with a gynaecological condition e.g. fibroids, endometriosis, Cysts? </label>
                  </div>
                  <div className='col-md-5'>
                    {/* <input type="text" className="form-control " placeholder="Height in meters " Value={MedicalHistory?.haveYouEverBeenDiagnosedWithaGynaecologic} /> */}
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" defaultValue={MedicalHistory?.haveYouEverHadAnyGynaecologicalTreatment}
                      name='haveYouEverHadAnyGynaecologicalTreatment' onChange={(e) => {
                        if (e.target.value === "271400001") { MedicalHistory.diagnosedwithaGynaecologicalIfYesPleasegive = "" }
                        updateMedicalhistory(e)
                      }} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.haveYouEverHadAnyGynaecologicalTreatment === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.haveYouEverHadAnyGynaecologicalTreatment === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                {MedicalHistory?.haveYouEverHadAnyGynaecologicalTreatment === 271400000 || MedicalHistory?.haveYouEverHadAnyGynaecologicalTreatment === "271400000" ?
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>If yes, please give details</label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " name='diagnosedwithaGynaecologicalIfYesPleasegive'
                        value={MedicalHistory?.diagnosedwithaGynaecologicalIfYesPleasegive} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                      {/* <input type="text" placeholder="Enter detail" className="form-control " name='lengthoftimewithyourcurrentpartner'
                        value={MedicalHistory?.lengthoftimewithyourcurrentpartner} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} /> */}
                    </div>
                  </div>
                  : null
                }
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Have you ever been Pregnant ?</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.haveyoueverbeenpregnant}
                      name='haveyoueverbeenpregnant' onChange={(e) => {
                        if (e.target.value === "271400001") { MedicalHistory.everbeenpregnantifyespleasegivedetail = "" }
                        updateMedicalhistory(e)
                      }} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.haveyoueverbeenpregnant === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.haveyoueverbeenpregnant === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                {MedicalHistory?.haveyoueverbeenpregnant === 271400000 || MedicalHistory?.haveyoueverbeenpregnant === "271400000" ?
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>If yes, please give details</label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " name='everbeenpregnantifyespleasegivedetail'
                        value={MedicalHistory?.everbeenpregnantifyespleasegivedetail} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                  : null
                }
              </div>
            </div>

            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Length of time with your current partner  </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " name='lengthoftimewithyourcurrentpartner'
                      value={MedicalHistory?.lengthoftimewithyourcurrentpartner} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Regularity of cycle</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='regularityofcycle'
                      defaultValue={MedicalHistory?.regularityofcycle} onChange={(e) => updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      <option value="0" selected={MedicalHistory?.regularityofcycle === 0}>Regular</option>
                      <option value="1" selected={MedicalHistory?.regularityofcycle === 1}>Irregular</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Is intercourse painful (Dyspareunia)?</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.isintercoursepainfuldyspareunia}
                      name='isintercoursepainfuldyspareunia' onChange={(e) => {
                        if (e.target.value === "271400001") { MedicalHistory.dyspareuniaifyespleasegivedetails = "" }
                        updateMedicalhistory(e)
                      }} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.isintercoursepainfuldyspareunia === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.isintercoursepainfuldyspareunia === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                {MedicalHistory?.isintercoursepainfuldyspareunia === 271400000 || MedicalHistory?.isintercoursepainfuldyspareunia === "271400000" ?
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>Dyspareunia? If yes, please give details</label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " name='dyspareuniaifyespleasegivedetails'
                        value={MedicalHistory?.dyspareuniaifyespleasegivedetails} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                  : null
                }
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Vaginal discharge (PV Discharge)? </label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.vaginaldischargepvdischarge}
                      name='vaginaldischargepvdischarge' onChange={(e) => {
                        if (e.target.value === "271400001") { MedicalHistory.pvdischargeifyespleasegivedetails = "" }
                        updateMedicalhistory(e)
                      }} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.vaginaldischargepvdischarge === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.vaginaldischargepvdischarge === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                {MedicalHistory?.vaginaldischargepvdischarge === 271400000 || MedicalHistory?.vaginaldischargepvdischarge === "271400000" ?
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>PV Discharge? If yes please give details </label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " name='pvdischargeifyespleasegivedetails'
                        value={MedicalHistory?.pvdischargeifyespleasegivedetails} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                  : null
                }
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Have you had a Large loop excision(LLETZ)?  </label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.haveyouhadalargeloopexcisionlletz}
                      name='haveyouhadalargeloopexcisionlletz' onChange={(e) => {
                        if (e.target.value === "271400001") { MedicalHistory.largeloopexcisiongivedetails = "" }
                        updateMedicalhistory(e)
                      }} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.haveyouhadalargeloopexcisionlletz === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.haveyouhadalargeloopexcisionlletz === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                {MedicalHistory?.haveyouhadalargeloopexcisionlletz === 271400000 || MedicalHistory?.haveyouhadalargeloopexcisionlletz === "271400000" ?
                  <div className='row '>
                    <div className='col-md-7'>
                      <label>LLETZ? If yes please give details </label>
                    </div>
                    <div className='col-md-5'>
                      <input type="text" placeholder="Enter detail" className="form-control " name='largeloopexcisiongivedetails'
                        value={MedicalHistory?.largeloopexcisiongivedetails} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                    </div>
                  </div>
                  : null
                }
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Family History of FGM (vulval cutting/surgery)  </label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.familyhistoryoffgmvulvalcuttingsurgery}
                      name='familyhistoryoffgmvulvalcuttingsurgery' onChange={(e) =>
                        updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.familyhistoryoffgmvulvalcuttingsurgery === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.familyhistoryoffgmvulvalcuttingsurgery === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Any Mental health issues  </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " name='anymentalhealthissues'
                      value={MedicalHistory?.anymentalhealthissues} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6  pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Origin of Grandparents (Maternal)</label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " name='originofgrandparentsmaternal'
                      value={MedicalHistory?.originofgrandparentsmaternal} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Origin of Grandparents (Paternal)</label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " name='originofgrandparentspaternal'
                      value={MedicalHistory?.originofgrandparentspaternal} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Origin of Parents (Father)   </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.originofparentspaternal}
                      name='originofparentspaternal' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Origin of Parents (Mother)    </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.originofparentsmaternal}
                      name='originofparentsmaternal' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Family History (relevant genetic disorders)   </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.familyhistoryrelevantgeneticdisorders}
                      name='familyhistoryrelevantgeneticdisorders' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
              <div className='col-md-6  pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label>Family History of deep vein thrombosis     </label>
                  </div>
                  <div className='col-md-5'>
                    <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.familyhistoryofdeepveinthrombosis}
                      name='familyhistoryofdeepveinthrombosis' onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e) }} />
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6 pe-5'>
                <div className='row '>
                  <div className='col-md-7'>
                    <label> Are the couple related / consanguineous?</label>
                  </div>
                  <div className='col-md-5'>
                    <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.arethecouplerelatedconsanguineous}
                      name='arethecouplerelatedconsanguineous' onChange={(e) =>
                        updateMedicalhistory(e)} >
                      <option >--Select--</option>
                      <option value="271400001" selected={MedicalHistory?.arethecouplerelatedconsanguineous === 271400001}>No</option>
                      <option value="271400000" selected={MedicalHistory?.arethecouplerelatedconsanguineous === 271400000}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>


      }
      <Modal size="lg" show={show} onHide={handleClose} >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4><b>Semen Analysis Detail</b></h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div className='row '>
            <h5><b>Sample Details</b></h5>
            <div className='col-md-6'>
              <b> Sample Production Date & Time:</b>
              {moment(popUpData?.sampleproductiondatetime).format('DD-MMM-YYYY')}
            </div>
            <div className='col-md-6'>
              <b>Abstinence (days):</b> {popUpData?.abstinence}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Sample Analysis Date & Time:</b>
              {moment(popUpData?.sampleanalysisdatetime).format('DD-MMM-YYYY')}
            </div>
            <div className='col-md-6'>
              <b> Liquefaction:</b>{popUpData?.liquefaction === true ? "Yes" :
                popUpData?.liquefaction === false ? "No" : null}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b> Sample Pot Used:</b>{popUpData?.sample_pot_used === 1 ? "Correct" :
                popUpData?.sample_pot_used === 2 ? "Silastic Condom" :
                  popUpData?.sample_pot_used === 3 ? "Non BCRM - Repeat Test" : null}
            </div>
            <div className='col-md-6'>
              <b>Viscosity:</b>{popUpData?.sample_pot_used === 1 ? "Increased" :
                popUpData?.sample_pot_used === 2 ? "Normal" :
                  popUpData?.sample_pot_used === 3 ? "Decreased" :
                    popUpData?.sample_pot_used === 4 ? "Significantly increased" : null}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Whole Sample Collected:</b>{popUpData?.wholesamplecollected === true ? "Yes" :
                popUpData?.wholesamplecollected === false ? "No" : null}
            </div>
            <div className='col-md-6'>
              <b>Appearance:</b> {popUpData?.bcrm_appearance === 271400000 ? "Normal" :
                popUpData?.bcrm_appearance === 271400001 ? "Translucent " :
                  popUpData?.bcrm_appearance === 271400002 ? "Discoloured" : null}
            </div>
          </div>
          <div className='row mt-3'>
            <h5><b>Raw Details</b></h5>
          </div>
          <div className='col-md-6 '>
            <b>pH:</b>{popUpData?.ph}
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Raw Progressive Motility (%): </b>{popUpData?.raw_progressive_motility}
            </div>
            <div className='col-md-6'>
              <b>Sample Volume(ml):</b>{popUpData?.samplevolume}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Raw Normal Forms (%):</b>{popUpData?.raw_normal_forms}
            </div>
            <div className='col-md-6'>
              <b>Concentration:</b>{popUpData?.bcrm_semen_concentration}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Sperm MAR% Bound:</b>{popUpData?.bcrm_sperm_mar}
            </div>
            <div className='col-md-6'>
              <b>Total Concentration:</b>{popUpData?.bcrm_total_concentration}
            </div>
          </div>
          <div className='row mt-3'>
            <h5><b>Recovery Details</b></h5>
          </div>
          <div className='row '>
            <div className='col-md-6'>
              <b>Recovery Volume (ml):</b>{popUpData?.bcrm_recovery_volume}
            </div>
            <div className='col-md-6'>
              <b>Recovery Count (m/ml):</b>{popUpData?.bcrm_recovery_count}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Raw Count (m/ml):</b>{popUpData?.bcrm_rawcount}
            </div>
            <div className='col-md-6'>
              <b>Recovery TMS (millions):</b>{popUpData?.bcrm_recovery_tms}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Recovery Progressive Motility (%):</b>{popUpData?.raw_progressive_motility}
            </div>
          </div>
          <div className='row mt-3'>
            <h5><b>Survival Details</b></h5>
          </div>
          <div className='row '>
            <div className='col-md-6'>
              <b>Survival Test Duration (hrs):</b>{popUpData?.survival_test_duration}
            </div>
            <div className='col-md-6'>
              <b>Survival TMS:</b>{popUpData?.bcrm_survival_tms}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Survival Progressive Motility (%):</b>{popUpData?.bcrm_survival_progressive_motility}
            </div>
          </div>
          <div className='row mt-3'>
            <h5><b>Comments</b></h5>
          </div>
          <div className='row '>
            <div className='col-md-6'>
              <b>Comments:</b>{popUpData?.bcrm_comments}
            </div>
          </div>
          <div className='row mt-3 '>
            <h5><b>Other Details</b></h5>
          </div>

          <div className='row mt-0'>
            <div className='col-md-6'>
              <b>First Name: </b>{popUpData?.bcrm_forename}
            </div>
            <div className='col-md-6'>
              <b> Date of Birth: </b>{popUpData?.dateofbirth !== "0001-01-01T00:00:00" ?
                moment(popUpData?.dateofbirth).format('DD-MMM-YYYY') : null}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Surname: </b>{popUpData?.bcrm_surname}
            </div>
            <div className='col-md-6'>
              <b>NHS Number: </b>{popUpData?.nhs_number}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Address1: </b>{popUpData?.bcrm_address1}
            </div>
            <div className='col-md-6'>
              <b>ID: </b>{popUpData?.bcrm_id}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Address2: </b>{popUpData?.bcrm_address2}
            </div>
            <div className='col-md-6'>
              <b>Legacy Clinic Number: </b>{popUpData?.clinicnumber}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Address3: </b>{popUpData?.bcrm_address3}
            </div>
            <div className='col-md-6'>
              <b>GP Name: </b>{popUpData?.bcrm_gp_name}
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-6'>
              <b>Postcode: </b>{popUpData?.bcrm_postcode}
            </div>
            <div className='col-md-6'>
              <b>Is Migrate:</b>
              {popUpData?.bcrm_is_migrate === true ? "Yes" :
                popUpData?.bcrm_is_migrate === false ? "No" : null}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
